import { IInspectionHook } from '@models';
import { Inspection, InspectionService } from '@services';
import { useEffect, useState } from 'react';

/**
 * Held locally rather than on the store. There is one inspection field on the store and more than one
 * consumer, so a second component mounting - the request side panel alongside the edit form - would
 * overwrite it, or clear it on the way out, and the form would repopulate itself from someone else's
 * inspection on top of whatever was being typed.
 */
export const useInspection = (id: string | undefined): IInspectionHook => {
  const [inspection, setInspection] = useState<Inspection | undefined>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      setInspection(undefined);
      return;
    }

    let cancelled = false;

    setLoading(true);

    InspectionService.get({ id })
      .then((result) => !cancelled && setInspection(result))
      .catch((error) => !cancelled && console.error(error))
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { loading, inspection };
};
